/*
 * @Author: lidan
 * @Date: 2021-06-07 11:31:23
 * @LastEditTime: 2021-06-07 11:33:08
 * @LastEditors: lidan
 * @Description: 智能找车
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\intelligentFindCar.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host, E6_MS_TMS_BUSI_WEB } = e6ModuleOrderWaybillProcessApi;

/* ************** 智能找车 **************** */
//智能找车列表查询
export function aiFindVehicle(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/aiFindVehicle`,
    method: "post",
    data
  });
}
//根据车id获取定位、时间等数据
export function findLocationInfoByVehicleId(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/findLocationInfoByVehicleId`,
    method: "post",
    data
  });
}
